<section class="not-found-container">
    <h2 class="heading">Access Denied</h2>
    <div>You do not have permission to access this page.</div>
  </section>
  